module.exports = __webpack_public_path__ + "media/images/flags/VC-14a4569493832d3e814c43f6a2eb6dbf.svg";